module.exports = __webpack_public_path__ + "static/media/dawulunshan_web.d4040db4.webp";